export default "__VITE_ASSET__ub9ARq$F__"